<script setup>
import { RadioGroup as HeadlessUiRadioGroup, RadioGroupLabel as HeadlessUiRadioGroupLabel } from "@headlessui/vue";
import FormErrors from "./Errors.vue";
import { useSlots } from "vue";
import { FormHelp, FormHint, FormLabel } from ".";

defineProps({
    modelValue: {},
    label: {
        type: String,
        default: undefined,
    },
    hint: {
        type: String,
    },
    help: {
        type: String,
    },
    z: {
        type: Number,
        default: 0,
    },
    errors: {
        type: Array,
        default: [],
    },
    by: {
        required: false,
    },
});

const emit = defineEmits(["update:modelValue"]);

const slots = useSlots();
</script>

<template>
    <HeadlessUiRadioGroup :modelValue="modelValue" @update:modelValue="(value) => emit('update:modelValue', value)" :by="by">
        <div :class="[label ? 'justify-between' : 'justify-end', 'flex items-center space-x-3']">
            <HeadlessUiRadioGroupLabel :as="FormLabel" v-if="label">
                {{ label }}
            </HeadlessUiRadioGroupLabel>
            <slot name="hint">
                <FormHint v-if="hint" :z="z">
                    {{ hint }}
                </FormHint>
            </slot>
        </div>

        <div :class="[label || hint || !!slots.hint ? 'mt-2' : '']">
            <slot></slot>
        </div>

        <slot name="help">
            <FormHelp v-if="help" class="mt-2">
                {{ help }}
            </FormHelp>
        </slot>

        <FormErrors v-if="errors" class="mt-2" :errors="errors" />
    </HeadlessUiRadioGroup>
</template>
